export enum ContentCardTypeEnum {
  Default = 'DEFAULT',
  Display = 'DISPLAY',
  Mini = 'MINI',
  Wide = 'WIDE',
}
